const EMAIL_INLINE_STYLES = 'margin: 0; padding: 0; min-height: 1.2em; line-height: 1.6;';

/**
 * Processes email HTML content to add inline styles for consistent rendering
 * across email clients. This ensures what you see in the preview matches
 * what gets sent.
 *
 * This function is idempotent - running it multiple times produces the same result.
 */
export function processEmailHtml(html: string): string {
  if (!html) return html;

  let processed = html;

  // Process all <p> tags - add base styles (idempotent)
  processed = processed.replace(
    /<p([^>]*)>/g,
    (match, attributes) => {
      // Skip if already processed
      if (attributes.includes('min-height: 1.2em')) {
        return match;
      }

      // Check if style attribute already exists
      if (attributes.includes('style="')) {
        // Append to existing style
        return match.replace(
          /style="([^"]*)"/,
          `style="$1; ${EMAIL_INLINE_STYLES}"`
        );
      } else {
        // Add new style attribute
        return `<p${attributes} style="${EMAIL_INLINE_STYLES}">`;
      }
    }
  );

  return processed;
}

/**
 * Removes processing styles from HTML (for editing purposes if needed)
 */
export function unprocessEmailHtml(html: string): string {
  if (!html) return html;

  // Remove the inline styles we added
  return html.replace(
    / style="margin: 0; padding: 0; min-height: 1\.2em; line-height: 1\.6;"/g,
    ''
  ).replace(
    /; margin: 0; padding: 0; min-height: 1\.2em; line-height: 1\.6;/g,
    ''
  );
}
